// 添加开发环境判断
const isDevelopment = process.env.NODE_ENV === 'development';
// 设置默认值
export const API_URL = process.env.REACT_APP_API_URL || (isDevelopment ? 'http://localhost:5001' : 'https://hateful-glass-production.up.railway.app');
export const GENERATE_NAME_ENDPOINT = `${API_URL}/api/generate-name-stream`;
